<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Draft Invoice</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    Invoice untuk <strong>{{ data.customer_name }}</strong><br />
                    Segmen harga <strong>{{ parsePriceSegment(data.price_segment) }}</strong> <br />
                    Dari gudang <strong>{{ data.warehouse }} - {{ data.office }}</strong><br />
                    Divisi <strong>{{ data.division }}</strong><br />
                    {{ data.total_item }} barang, total Rp. {{ $helper.formatThousand(data.total_price) }}
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="danger" @click="promptCancelInvoice">
                        <i class="fa fa-times mr-2" />Batalkan
                    </b-button>
                    <b-button variant="success" class="ml-2" @click="finalizeInvoice">
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button><br>
                    <b-button variant="primary" class="mt-3" @click="promptEditInvoice">
                        <i class="fa fa-pencil mr-2" />Ubah Customer
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <b-input-group>
                        <b-input v-model="input.noFaktur" maxlength="100" style="max-width: 250px" placeholder="Input No. Faktur..." @keydown.enter="findItem" />
                        <b-input-group-append>
                            <b-button variant="dark" @click="findItem">Cari Barang</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
<!--                 <b-col md="6" class="text-right">
                    <b-button variant="warning" @click="$bvModal.show('m-pick-price-segment')">
                        Segmen Harga: <strong>{{ parsePriceSegment(data.price_segment) }}</strong>
                    </b-button>
                </b-col> -->
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.items"
                :fields="fields"
                responsive class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Invoice masih kosong.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}<br />
                        Ctt: {{ row.item.note || "-" }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                        Grade <strong>{{ row.item.grade }} - {{ row.item.spec }} - {{ row.item.is_batangan ? 'BATANG' : 'LENGKAP' }}</strong><br />
                        Kloter {{ $helper.parseDate(row.item.created) }}
                    </div>
                </template>
                <template v-slot:cell(basePrice)="row">
                    Rp. {{ $helper.formatThousand(row.item.base_price) }}
                </template>
                <template v-slot:cell(adjustment)="row">
                    <p class="mb-0" v-if="row.item.adjustment.negative.value != '0'">
                        Total Potongan: Rp. {{ $helper.formatThousand(row.item.adjustment.negative.value) }}
                    </p>
                    <p class="mb-0" v-if="row.item.adjustment.positive.value != '0'">
                        Total Tambahan: Rp. {{ $helper.formatThousand(row.item.adjustment.positive.value) }}
                    </p>
                    <p class="mb-0" v-if="row.item.adjustment.negative.value == '0' && row.item.adjustment.positive.value == '0'">Rp. 0</p>
                    <!-- Rp. {{ $helper.formatThousand(row.item.adjustment.negative.value) }} ({{ row.item.adjustment.negative.count }} Minus)
                    <div class="small text-muted">
                        Rp. {{ $helper.formatThousand(row.item.adjustment.positive.value) }} ({{ row.item.adjustment.positive.count }} Plus)
                    </div> -->
                    <div class="small text-muted">
                        Rp. {{ $helper.formatThousand(row.item.adjustment.price_segment) }} ({{ parsePriceSegment(data.price_segment) }})
                    </div>
                </template>
                <template v-slot:cell(subtotal)="row">
                    Rp. {{ $helper.formatThousand(row.item.total) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" class="mr-2" v-b-tooltip.hover.top title="Edit" @click="promptEditItem(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" @click="promptRemoveItem(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <b-modal id="m-photo" title="Foto Barang" hide-footer>
            No. Faktur <strong>{{ activeItem.no_faktur_pgi }}</strong><br />
            {{ activeItem.type }} <span v-if="activeItem.year != null">({{ activeItem.year }})</span> - {{ activeItem.brand }} - {{ activeItem.kind }}
            <br /><br />
            <img :src="$BASE_FILE_PATH + '/' + activeItem.photo" width="100%" />
        </b-modal>
        <b-modal id="m-item-to-add" size="xl" :title="invoiceDetailId == null ? 'Penambahan Barang' : 'Pengubahan Barang'" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <ModalItemDrafting :noFaktur="noFakturPGI" :invoiceId="Number($route.params.id)" :invoiceDetailId="invoiceDetailId" @item-added="onItemAdded" />
        </b-modal>
        <b-modal id="m-finalize-discount" title="Finalisasi - Diskon" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="No. Ref Invoice" description="Wajib diisi. No. Ref akan ditampilkan di invoice. Maks. 20 karakter.">
                <b-input v-model="finalize.noRef" maxlength="20" />
            </b-form-group>
            <b-form-group label="Tanggal Penjualan" description="Wajib diisi. Tanggal Penjualan yang akan dimunculkan di cetakan invoice sales.">
                <b-input v-model="finalize.soldAt" type="date" />
            </b-form-group>
            <b-form-group label="Diskon (Nominal Total)" description="Diskon yang diberikan dalam bentuk nominal rupiah. Melakukan pemotongan dari grand total invoice.">
                <b-input-group prepend="Rp.">
                    <b-input v-model="finalize.discount" @input="sanitizeDiscount" type="text" step="1" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Diskon (Persentase)" description="Diskon yang diberikan dalam bentuk persentase. Isi dengan nol apabila tidak ada diskon. Diskon dibulatkan ke 2 bilangan desimal terdekat.">
                <b-input-group append="%">
                    <b-input v-model="finalize.discountPercent" type="text" step="1" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 44 || event.charCode == 46" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Catatan Invoice / Diskon (Opsional)">
                <b-input v-model="finalize.note" maxlength="200" />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="moveToConfirmation">
                    Lanjutkan
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-finalize-confirm" title="Finalisasi Invoice" centered no-close-on-backdrop no-close-on-esc hide-footer :hide-header-close="isSubmitting">
            Konfirmasi akhir untuk pengukuhan invoice.
            <div class="mt-3">
                <div>
                    <strong>No. Ref</strong><br />
                    {{ finalData.noRef }}
                </div>
                <div class="mt-3">
                    <strong>Tanggal Penjualan</strong><br />
                    {{ $helper.parseDate(finalData.sold_at) }}
                </div>
                <div class="mt-3">
                    <strong>Customer</strong><br />
                    {{ finalData.customer }}
                </div>
                <div class="mt-3">
                    <strong>Catatan</strong><br />
                    {{ finalize.note || "-" }}
                </div>
                <div class="mt-3">
                    <strong>Total Belanja</strong><br />
                    {{ finalData.total_item }} item(s), Rp. {{ $helper.formatThousand(finalData.total_price) }}
                </div>
                <div class="mt-3">
                    <strong>Diskon Persentase</strong><br />
                    {{ finalData.discount_percent ? finalData.discount_percent + " %" : 0 + " %" }}
                </div>
                <div class="mt-3">
                    <strong>Diskon Nominal</strong><br />
                    Rp. {{ finalData.discount ? $helper.formatThousand(finalData.discount) : 0 }}
                </div>
                <div class="mt-3">
                    <strong>Total Pembayaran Akhir (Setelah Dikurangi Diskon)</strong><br />
                    Rp. {{ $helper.formatThousand(finalData.total_price_after_discount) }}
                </div>
                <div class="mt-3">
                    <strong>Sisa Deposit Customer</strong><br />
                    Rp. {{ $helper.formatThousand(finalData.deposit) }}
                </div>
                <div class="mt-3">
                    <strong>Harga Akhir (Setelah Dikurangi Deposit)</strong><br />
                    Rp. {{ $helper.formatThousand(finalData.final_price) }}
                </div>
                <div class="mt-4 text-right">
                    <b-button variant="primary" :disabled="isSubmitting" @click="execConfirmInvoice">
                        {{ isSubmitting ? "Memproses..." : "Transaksikan Invoice" }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-pick-price-segment" title="Set Segmen Harga" centered size="sm" hide-footer no-close-on-backdrop no-close-on-esc>
            <b-button block :variant="data.price_segment == 1 ? 'primary' : 'light'" :disabled="isSubmitting" @click="switchSegment(1)">Grosir Offline</b-button>
            <b-button block :variant="data.price_segment == 2 ? 'primary' : 'light'" :disabled="isSubmitting" @click="switchSegment(2)">Grosir Online</b-button>
            <b-button block :variant="data.price_segment == 3 ? 'primary' : 'light'" :disabled="isSubmitting" @click="switchSegment(3)">Retail</b-button>
        </b-modal>
        <b-modal id="m-pin" :title="pinTitle" centered hide-footer>
            <b-form-group label="Masukan PIN">
                <b-input type="password" v-model="pin" maxlength="10" @keydown.enter="checkPIN" autofocus />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="checkPIN">
                    Otorisasi
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Ubah Customer" centered hide-footer>
            <b-form-group label="Invoice ditujukan untuk...">
                <multiselect v-model="edit.customer"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="edit.optCustomer"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting || edit.customer == null" @click="confirmEditInvoice">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-print" title="Cetak Invoice" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
            Invoice berhasil dibuat. Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            Pastikan invoice sudah tercetak baik sebelum menekan tombol OK.
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="finishInvoice">
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalItemDrafting from './ModalItemDrafting.vue'

export default {
    components: {
        ModalItemDrafting
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            noFakturPGI: "",
            invoiceDetailId: null,
            pin: "",
            pinTitle: "",
            afterPin: "",
            invoiceLink: "",
            invoiceLinkA4: "",

            data: {
                items: []
            },

            input: {
                noFaktur: ""
            },

            finalize: {
                discount: "",
                discountAll: "",
                discountPercent: "",
                dp: "",
                fullPayment: true,
                note: "",
                noRef: "",
                soldAt: "",

                totalPriceAfterDiscount: 0
            },

            finalData: {},

            fields: [
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "basePrice", label: "Harga Dasar", sortable: true },
                { key: "adjustment", label: "Potongan / Tambahan Harga", sortable: true },
                { key: "subtotal", label: "Subtotal", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            activeItem: {
                id: null,
                no_faktur_pgi: "",
                photo: ""
            },

            edit: {
                customer: "",
                optCustomer: []
            },

            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false

        }
    },

    watch: {

        "finalize.dp": function(newVal) {

            let cleaned = String(newVal).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.finalize.dp = res)

        }

    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getItems()

            let getCustomers = this.$axios.get("customer/selection").then(res => {
                this.edit.optCustomer = res.data.data
            }).catch(error => this.$helper.parseError(this, error))

            Promise.all([getData, getCustomers]).then(() => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("invoice/draft/" + this.$route.params.id + param).then(res => {
                this.data = res.data.data
            }).catch(error => this.$helper.parseError(this, error))

        },

        findItem() {

            if(this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor faktur!")
            }

            this.invoiceDetailId = null
            this.noFakturPGI = this.input.noFaktur
            this.$bvModal.show("m-item-to-add")

        },

        promptRemoveItem(item) {

            let confirmed = confirm(`Hapus ${item.type} (NF ${item.no_faktur_pgi}) dari invoice ini?`)
            if(!confirmed) return

            this.activeItem = item
            this.afterPin = "cancel-item"
            this.pinTitle = "Pembatalan Barang - NF " + item.no_faktur_pgi
            this.$bvModal.show("m-pin")

        },

        execRemoveItem() {

            let payload = {
                invoice_detail_id: this.activeItem.id,
                invoice_id: this.$route.params.id,
                pin: this.pin
            }

            this.$axios.post("invoice/remove-item", payload).then(res => {
                this.$helper.toastSuccess(this, "Barang berhasil dihapus dari invoice!")
                this.pin = ""
                this.init()
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        onItemAdded(toastMessage) {

            this.$bvModal.hide("m-item-to-add")
            this.$helper.toastSuccess(this, toastMessage)
            this.input.noFaktur = ""
            this.noFakturPGI = ""
            this.invoiceDetailId = null
            this.init()

        },

        promptCancelInvoice() {

            let isConfirmed = confirm("Batalkan invoice ini? Invoice akan dihapus dan barang-barang akan dikembalikan ke status semula!")
            if(!isConfirmed) return

            this.afterPin = "cancel-invoice"
            this.pinTitle = "Pembatalan Invoice"
            this.$bvModal.show("m-pin")

        },

        promptEditInvoice() {

            this.$bvModal.show("m-edit")

        },

        confirmEditInvoice() {

            this.afterPin = "edit-customer"
            this.pinTitle = "Perubahan Customer"
            this.$bvModal.show("m-pin")

        },

        execEditInvoice() {

            this.isSubmitting = true
            let payload = {
                id: this.$route.params.id,
                customer_id: this.edit.customer.id
            }

            this.$axios.post("invoice/update-invoice-draft", payload).then(res => {
                this.$helper.toastSuccess(this, "Customer Invoice berhasil diubah!")
                this.pin = ""
                this.init()
                this.$bvModal.hide("m-edit")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execCancelInvoice() {

            let payload = {
                id: this.$route.params.id,
                pin: this.pin
            }

            this.$axios.post("invoice/cancel", payload).then(_ => {
                this.$router.push({ path: "/sales/invoice" })
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        finalizeInvoice() {

            if(this.data.items.length == 0) {
                return this.$helper.toastError(this, "Invoice masih kosong / tidak ada barang!")
            }

            this.$bvModal.show("m-finalize-discount")

        },

        // moveToPaymentMethod() {

        //     if(this.$helper.isBlank(this.finalize.discount)) {
        //         return this.$helper.toastError(this, "Mohon mengisi diskon!")
        //     }

        //     let payload = this.getFinalizePayload(2)
        //     if(typeof payload === "string") return this.$helper.toastError(this, payload)

        //     this.isSubmitting = true
        //     this.$axios.post("invoice/finalize", payload).then(res => {


        //         this.$bvModal.show("m-finalize-discount")

        //     })
        //     .catch(error => this.$helper.parseError(this, error))
        //     .finally(() => this.isSubmitting = false)

        // },

        moveToConfirmation() {

            let payload = this.getFinalizePayload(2)
            if(typeof payload === "string") return this.$helper.toastError(this, payload)

            this.isSubmitting = true
            this.$axios.post("invoice/finalize", payload).then(res => {

                this.finalize.totalPriceAfterDiscount = res.data.data.total_price_after_discount
                this.finalData = res.data.data
                this.$bvModal.show("m-finalize-confirm")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execConfirmInvoice() {

            let isConfirmed = confirm("Transaksikan invoice ini? Invoice yang sudah ditransaksikan tidak dapat dibatalkan!")
            if(!isConfirmed) return

            let payload = {
                id: this.$route.params.id,
                stage: 9,
                fullPayment: this.finalData.is_fully_paid,
                note: this.finalize.note,
                noRef: this.finalData.noRef,
                soldAt: this.finalData.sold_at,
                discount: 0.00,
                discountPercent: 0.00
            }

            if(!this.$helper.isBlank(this.finalData.discount)){
                payload.discount = this.finalData.discount
            }
            if(!this.$helper.isBlank(this.finalData.discount_percent)){
                payload.discountPercent = this.finalData.discount_percent
            }

            if(this.finalData.is_fully_paid == false) {
                payload.dp = this.finalData.dp
            }

            this.isSubmitting = true
            this.$axios.post("invoice/finalize", payload).then(res => {

                this.$bvModal.hide("m-finalize-confirm")
                this.invoiceLink = `${this.$BASE_PRINT_FILE_PATH}/${res.data.data.link}`
                this.invoiceLinkA4 = `${this.$BASE_PRINT_FILE_PATH}/${res.data.data.linka4}`
                this.$bvModal.show("m-print")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        finishInvoice() {
            this.$router.push({ path: "/sales/invoice" })
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return this.invoiceLink
            }
            else{
                return this.invoiceLinkA4
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

        getFinalizePayload(stage) {

            let payload = {
                id: this.$route.params.id,
                stage: stage
            }

            if(stage >= 2) { // Diskon

                let discountPercent = Number(this.finalize.discountPercent.replace(',','.').replace(' ','')).toFixed(2)
                if(discountPercent < 0 || discountPercent > 100) {
                    return "Diskon harus antara 0 dan 100%!"
                }

                if(this.$helper.isBlank(this.finalize.noRef)) {
                    return "Mohon mengisi No. Ref Invoice!"
                }

                if(this.$helper.isBlank(this.finalize.soldAt)) {
                    return "Mohon mengisi tanggal penjualan!"
                }

                payload.discountPercent = 0
                payload.discount = 0

                if(!this.$helper.isBlank(this.finalize.discount)) payload.discount = this.$helper.toNumber(this.finalize.discount)
                if(!this.$helper.isBlank(this.finalize.discountPercent)) payload.discountPercent = discountPercent

                payload.noRef = this.finalize.noRef
                payload.soldAt = this.finalize.soldAt

            }

            if(stage >= 3) { // DP dan pembayaran

                payload.fullPayment = this.finalize.fullPayment
                if(!this.finalize.fullPayment) {

                    if(this.$helper.isBlank(this.finalize.dp)) {
                        return "Mohon mengisi jumlah DP yang akan dibayarkan!"
                    }

                    let dp = this.$helper.toNumber(this.finalize.dp)
                    if(dp <= 0) return "DP tidak boleh lebih kecil dari nol!"
                    if(dp > this.finalize.totalPriceAfterDiscount) return "DP lebih besar daripada total harga! Gunakan metoda pembayaran lunas!"

                    payload.dp = dp

                }

            }

            return payload

        },

        promptEditItem(item) {

            this.activeItem = item
            this.afterPin = "edit-item"
            this.pinTitle = "Edit Barang - NF " + item.no_faktur_pgi
            this.$bvModal.show("m-pin")

        },

        execEditItem() {
            this.invoiceDetailId = this.activeItem.id
            this.noFakturPGI = this.activeItem.no_faktur_pgi
            this.$bvModal.show("m-item-to-add")
        },

        switchSegment(newSegment) {

            if(newSegment == this.data.price_segment) {
                return
            }

            let isConfirmed = confirm("Ubah segmen harga untuk invoice ini?")
            if(!isConfirmed) return

            this.isSubmitting = true
            let payload = {
                invoice_id: this.$route.params.id,
                price_segment: newSegment
            }

            this.$axios.post("invoice/switch-segment", payload).then(res => {

                this.$bvModal.hide("m-pick-price-segment")
                this.$helper.toastSuccess(this, "Segmen harga berhasil diubah!")
                this.init()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        checkPIN() {

            if(this.pin == "") return this.$helper.toastError(this, "PIN kosong!")

            let payload = {
                pin: this.pin
            }

            this.isSubmitting = true
            this.$axios.post("invoice/check-pin", payload).then(_ => {

                this.$bvModal.hide("m-pin")

                switch(this.afterPin) {
                    case "cancel-invoice":
                        this.execCancelInvoice()
                        break

                    case "cancel-item":
                        this.execRemoveItem()
                        break

                    case "edit-customer":
                        this.execEditInvoice()
                        break

                    case "edit-item":
                        this.execEditItem()
                        this.pin = ""
                        break

                    default: break

                }

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        parsePriceSegment(segment) {
            switch(segment) {
                case 0: return "Draft"
                case 1: return "Grosir Offline"
                case 2: return "Grosir Online"
                case 3: return "Retail"
                default: return "-"
            }
        },

        sanitizeDiscount() {
            let cleaned = String(this.finalize.discount).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.finalize.discount = res
        },

        sanitizeDiscountAll() {
            let cleaned = String(this.finalize.discountAll).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.finalize.discountAll = res
        }

    },
    created() {

        this.init()

        let tzoffset = (new Date()).getTimezoneOffset() * 60000
        let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
        this.finalize.soldAt = localISOTime.substring(0, 10)

    }
}
</script>

<style>

</style>
